import { get } from 'lodash';
import {
  InspectionResult,
  PropertyContacts,
} from '../../api/ariadne/__generated_types__/graphql';
import { InspectionQuestionResult, InspectionResultColor } from '../constants';
import { Question } from './types';

export const getQuestionResult = (
  question: Question,
  inspectionResult?: InspectionResult,
  questionResult?: InspectionQuestionResult | string | null,
  apnData?: PropertyContacts
) => {
  // If the question has a prefill_from value, that means this question is not answerable
  // by the user but is prefilled from the apnData.
  if (question.prefill_from) {
    const value = get(apnData, question.prefill_from);
    return value;
  }

  if (!inspectionResult) return InspectionQuestionResult.NOT_STARTED;

  // This means inspection is either in progress or completed and we don't have the result for a question
  // If there is no response for a question, then default the displayed value to "-".
  if (!questionResult) return '-';

  return questionResult;
};

export const getQuestionResultColor = (
  inspectionResult?: InspectionQuestionResult | null
) => {
  if (!inspectionResult) return null;

  return InspectionResultColor[inspectionResult];
};
